import { Injectable } from '@angular/core';

export interface RuntimeConfig {
  API_URL_SQL_REPORT: string;
}

@Injectable({
  providedIn: 'root',
})
export class RuntimeConfigService {
  private config: RuntimeConfig = {
    API_URL_SQL_REPORT: '',
  };

  load(): Promise<void> {
    return fetch('/runtime-config.json')
      .then((response) => response.json())
      .then((config: RuntimeConfig) => {
        this.config = config;
      })
      .catch(() => {
        console.warn('runtime-config.json not found, using defaults');
      });
  }

  get apiUrlSqlReport(): string {
    return this.config.API_URL_SQL_REPORT;
  }
}
